import Thumbnail, { ThumbnailProps } from './Thumbnail';

export default Thumbnail;
export type { ThumbnailProps };
